export default {
  state: {
    video: '123'
  },
  getters: {
    video: state => state.video
  },
  actions: {
  },
  mutations: {
    setvideo (state, data) {
      this.state.youtube.video = JSON.parse(JSON.stringify(data))
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/youtube.js